import { isCommission } from '../types/index.js';

const SHARE_MAX_PRICE = 150;

/**
 * Recalculates the retail balance based on sold shares, share price, and commission percentage.
 *
 * @param soldShares The number of shares sold.
 * @param sharePrice The price per share.
 * @param commissionPercent The commission percentage to apply.
 * @returns The recalculated retail balance.
 * @throws {Error} Will throw an error if the commission percentage is invalid.
 */
export function recalculateRetailBalance(soldShares: number, sharePrice: number, commissionPercent: number): number {
  if (!isCommission(commissionPercent)) {
    throw new Error('Invalid commission percentage');
  }

  let maxPlayableAmount = (soldShares * sharePrice) / (1 + commissionPercent / 100);
  maxPlayableAmount = Math.max(maxPlayableAmount, soldShares * sharePrice - soldShares * SHARE_MAX_PRICE);

  return Math.floor(Math.round(maxPlayableAmount * 100) / 100);
}
